import { useContext } from "react";
import { http } from "~/services/http";
import useSWRMutation from "swr/mutation";
import { PreviewModeContext, isLiveMode } from "~/context/PreviewModeContext";

const fetcher = (url, { arg: uuid }) => {
  return http.get(`/api/studyfile/${uuid}`);
};

export function useFetchFileInfo() {
  const { mode } = useContext(PreviewModeContext);
  const isPreviewOrPrint = !isLiveMode(mode);

  const swrKey = isPreviewOrPrint ? null : "/api/studyfile";
  const { trigger: fetchFileInfo } = useSWRMutation(swrKey, fetcher);

  if (isPreviewOrPrint) {
    return { fetchFileInfo: () => Promise.resolve(null) };
  }

  return { fetchFileInfo };
}
